import CheckboxRenderer from "./renderer/CheckboxRenderer";
import Col from "react-bootstrap/Col";
import PropTypes from "prop-types";
import QuestionHeader from "./QuestionHeader";
import React from "react";
import Row from "react-bootstrap/Row";
import { isAnswered } from "../../../../utils/QuestionUtils";

/**
 * Check box question component for survey-view.
 */
const CheckboxQuestion = ({
  disabled,
  question,
  questionAnswer,
  addQuestionAnswer,
  setQuestionAnswer,
  removeQuestionAnswer
}) => {
  const collection = questionAnswer.answers;

  return (
    <Row>
      <Col lg={12} md={12} sm={12}>
        <QuestionHeader question={question} answered={isAnswered(question, questionAnswer)}>
          <CheckboxRenderer
            defaultStyle
            disabled={disabled}
            question={question}
            collection={collection}
            addQuestionAnswer={addQuestionAnswer}
            setQuestionAnswer={setQuestionAnswer}
            removeQuestionAnswer={removeQuestionAnswer}
          />
        </QuestionHeader>
      </Col>
    </Row>
  );
};

CheckboxQuestion.propTypes = {
  disabled: PropTypes.bool,
  question: PropTypes.object,
  questionAnswer: PropTypes.object,
  addQuestionAnswer: PropTypes.func,
  setQuestionAnswer: PropTypes.func,
  removeQuestionAnswer: PropTypes.func
};

export default CheckboxQuestion;
